import React, { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { useXR, useXRInputSourceState, useXRControllerLocomotion } from "@react-three/xr";
import { Text } from "@react-three/drei";
import * as THREE from "three";
import { readoutsFor, GOLD } from "../lib/storm";

// Smooth thumbstick locomotion (moves the XR origin) — only runs in a session
function Locomotion({ originRef }) {
  useXRControllerLocomotion(originRef, { speed: 2.2 });
  return null;
}

function WristPanel({ handed, children }) {
  const state = useXRInputSourceState("controller", handed);
  const ref = useRef();
  useFrame(() => {
    const obj = state?.object;
    if (ref.current && obj) {
      obj.updateWorldMatrix(true, false);
      ref.current.position.setFromMatrixPosition(obj.matrixWorld);
      ref.current.quaternion.setFromRotationMatrix(obj.matrixWorld);
    }
  });
  return <group ref={ref}>{children}</group>;
}

// Left wrist: live metrics + clock. Right wrist: audio state. Anchored spatial HUD.
export default function VRControls({ sim, originRef, timeLabel, audio }) {
  const session = useXR((s) => s.session);
  if (!session) return null;
  const r = readoutsFor(sim.current.intensity);
  return (
    <>
      <Locomotion originRef={originRef} />
      <WristPanel handed="left">
        <group position={[0, 0.04, -0.04]} rotation={[-0.9, 0, 0]}>
          <mesh><planeGeometry args={[0.13, 0.08]} /><meshBasicMaterial color="#0a0e1a" transparent opacity={0.8} /></mesh>
          <Text font="/fonts/Cinzel.ttf" position={[0, 0.022, 0.001]} fontSize={0.012} color={GOLD} anchorX="center">{timeLabel}</Text>
          <Text position={[0, 0.004, 0.001]} fontSize={0.011} color="#fff" anchorX="center">{r.wind} mph · {r.pressure} mb</Text>
          <Text position={[0, -0.014, 0.001]} fontSize={0.009} color="#cfd6e4" anchorX="center">{r.label}</Text>
        </group>
      </WristPanel>
      <WristPanel handed="right">
        <group position={[0, 0.04, -0.04]} rotation={[-0.9, 0, 0]}>
          <mesh><planeGeometry args={[0.13, 0.06]} /><meshBasicMaterial color="#0a0e1a" transparent opacity={0.8} /></mesh>
          <Text font="/fonts/Cinzel.ttf" position={[0, 0.012, 0.001]} fontSize={0.011} color={GOLD} anchorX="center">AUDIO</Text>
          <Text position={[0, -0.008, 0.001]} fontSize={0.009} color="#fff" anchorX="center">{audio?.mute ? "MUTED" : `Chaos ${Math.round((audio?.chaos ?? 0.7) * 100)}%`}</Text>
        </group>
      </WristPanel>
    </>
  );
}
